import { IsNotEmpty } from "class-validator";

import { AdapterCrewCraftDto } from "../adapter-crew-craft.dto";

export class SapAdapterCrewCraftDto extends AdapterCrewCraftDto {
  //
  @IsNotEmpty()
  WorkCenterId: string;
}
